import type { NavigateFunction } from 'react-router';

export const safeNavigate = (navigate: NavigateFunction, navigateTo?: string | null): void => {
  const redirect = navigateTo?.includes('https');
  if (redirect && navigateTo) {
    window.location.href = navigateTo;
  } else {
    if (navigateTo) {
      navigate(navigateTo);
    }
  }
};
